// i18n keys of the multi-tenant work package "zone": the city a reader knows each offered time zone by,
// for "{{zone}} time" labels (src/utils/region.ts zoneCity). Key = 'tzc_' + IANA id with every
// non-letter turned into '_'. A zone not listed here falls back to its English city name.
// ⛔ Fill all three: an empty th value falls back to English.
const ZONES: Array<[string, string, string, string]> = [
  // IANA id,              en,             zh,         th
  ['Asia/Bangkok',         'Bangkok',      '曼谷',     'กรุงเทพฯ'],
  ['Asia/Singapore',       'Singapore',    '新加坡',   'สิงคโปร์'],
  ['Asia/Kuala_Lumpur',    'Kuala Lumpur', '吉隆坡',   'กัวลาลัมเปอร์'],
  ['Asia/Ho_Chi_Minh',     'Ho Chi Minh',  '胡志明市', 'โฮจิมินห์'],
  ['Asia/Phnom_Penh',      'Phnom Penh',   '金边',     'พนมเปญ'],
  ['Asia/Jakarta',         'Jakarta',      '雅加达',   'จาการ์ตา'],
  ['Asia/Makassar',        'Makassar',     '望加锡',   'มากัสซาร์'],
  ['Asia/Jayapura',        'Jayapura',     '查亚普拉', 'จายาปุระ'],
  ['Asia/Manila',          'Manila',       '马尼拉',   'มะนิลา'],
  ['Asia/Hong_Kong',       'Hong Kong',    '香港',     'ฮ่องกง'],
  ['Asia/Shanghai',        'Shanghai',     '上海',     'เซี่ยงไฮ้'],
  ['Australia/Sydney',     'Sydney',       '悉尼',     'ซิดนีย์'],
  ['Australia/Melbourne',  'Melbourne',    '墨尔本',   'เมลเบิร์น'],
  ['Australia/Brisbane',   'Brisbane',     '布里斯班', 'บริสเบน'],
  ['Australia/Perth',      'Perth',        '珀斯',     'เพิร์ท'],
  ['Australia/Adelaide',   'Adelaide',     '阿德莱德', 'แอดิเลด'],
];
const key = (z: string) => 'tzc_' + z.replace(/[^A-Za-z]/g, '_');
const col = (i: 1 | 2 | 3): Record<string, string> => Object.fromEntries(ZONES.map(r => [key(r[0]), r[i]]));
export const en: Record<string, string> = col(1);
export const zh: Record<string, string> = col(2);
export const th: Record<string, string> = col(3);
